import PageLoader from './page-loader';

export default PageLoader;
